export default {
  methods: {
    async formLoad() {
      this.error = false;
      this.errmsg = null;
      this.loading = true;
      const rowId = this.$route.params.rowId || "new";
      this.submitId = rowId;
      try {
        const response = (await this.$axios({
          url: `forms/client/${this.$route.params.formId}/${rowId}`,
          method: "get"
        })).data;

        const form = response.results;
        if (form.redirected) {
          this.submitId = form.submitId;
        }
        this.title = form.title;
        this.description = form.description;
        this.model = form.model;
        this.questions = form.questions;
        this.$root.confirmationTitle = form.confirmationTitle;
        this.$root.confirmationMessage = form.confirmationMessage;
      } catch (e) {
        this.handleError(e);
      }
      this.loading = false;
    }
  }
};
